import React, { Component } from "react"
import AppInfoImage from "./AppInfoImage"

import google from "../images/google-play-store.svg"
import apple from "../images/apple-store.svg"

export default class AppInfo extends Component {
  render() {
    return (
      <>
        <section id="app_info" class="app_info lg:px-0 px-8">
          <div class="container mx-auto">
            <div class="flex flex-wrap">
              <div class="lg:w-1/2 w-full">
                <div class="app_info__image lg:justify-center justify-start lg:mb-0 mb-10">
                  <AppInfoImage />
                </div>
              </div>
              <div class="lg:w-1/2 w-full flex justify-center items-center">
                <div class="app_info__content">
                  <p class="heading mb-0">
                    Explore <span>better</span> with our{" "}
                    <span>mobile app.</span>
                  </p>
                  <p class="text-gray-700 mt-10 mb-0 leading-loose lg:w-9/12 w-full">
                    Register yourself on the app, and you are ready to dive into
                    the world of awesomeness.
                  </p>
                  <p className="text-gray-700 mt-3 mb-0 leading-loose lg:w-9/12 w-full">
                    Explore exclusive offers from all around the city and avail
                    them at your convenience!
                  </p>
                  <div class="app__download mt-10">
                    <div>
                      <span>available on</span>
                      <a href="#">
                        <img src={google} alt="" srcset="" />
                      </a>
                      <a href="#">
                        <img src={apple} alt="" srcset="" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
    )
  }
}
